import CustomModal from '../../../../../v2-components/Antd/Modal';
import CustomButton from '../../../../../v2-components/Antd/Button';
import CustomDivider from '../../../../../v2-components/Antd/Divider';
import { checkRecipe } from './handle/check-recipe.handle';

export default function RecipeModal(props) {
	return (
		<CustomModal onCancel={() => props?.setOpenRecipe(false)} footer={null} open={props?.openRecipe}>
			<h2>Receta adjunta</h2>
			<CustomDivider />
			{checkRecipe(props?.recipe)}
			<CustomDivider />
			<CustomButton onClick={() => props?.setOpenRecipe(false)}>Salir</CustomButton>
		</CustomModal>
	);
}
